export const MAX_SUPPLY_DAYS = 7;
